module.exports = __webpack_public_path__ + "static/img/cwgl_p2.d0e0c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/cwgl_p2.png
// module id = /x9h
// module chunks = 19